module.exports = __webpack_public_path__ + "img/coin.b9d61669.svg";